module.exports = __webpack_public_path__ + "img/windowsStep2.1d9b1fcb.png";